<template>
    <div>
        <div class="page-title">
            <h4> Lista Roluri </h4>
        </div>
        <div class="template-add-role">
            <button type="button" class="template-add-btn" @click="$router.push('/roles/create')">
                <i class="fas fa-plus-circle"></i> {{$t('txt.adaugaRol')}}
            </button>
        </div>
        <table class="table app_table">
            <thead>
            <tr class="app_table_header">
                <th scope="col"> {{$t('tableHeader.id')}}</th>
                <th scope="col"> {{$t('tableHeader.denumire')}}</th>
                <th scope="col"> {{$t('tableHeader.optiuni')}}</th>
            </tr>
            </thead>
            <tbody v-if="roles">
                <tr v-for="(role, index) in roles" :key="index">
                <td :tableheadData="$t('tableHeader.id')"> {{role.id}}</td>
                <td :tableheadData="$t('tableHeader.denumire')">{{ namingRoles($t(`roles.${role.name}`)) }}<!--{{$t(`roles.${role.name}`)}}--></td>
                <td :tableheadData="$t('tableHeader.nume')" class="options-case">
                    <router-link :to="{ name: 'editrole', params: { id: role.id }}" class="edit-user"
                                 data-placement="top" data-toggle="tooltip" :title="$t('placeholder.editeaza')">
                        <i class="fas fa-pen"></i>
                    </router-link>
                </td>
            </tr>
            </tbody>
            <tbody v-else>
            <tr>
                <td colspan="3" v-if="this.$store.state.loading">{{$t('txt.loading')}}</td>
                <td colspan="3" v-else>{{$t('errors.emptyResult')}}</td>
            </tr>
            </tbody>
            <tfoot v-if="roles">
                <tr class="app_table_header">
                    <th scope="col">
                        {{$t('tableHeader.id')}}
                    </th>
                    <th scope="col">
                        {{$t('tableHeader.denumire')}}
                    </th>
                    <th scope="col">
                        {{$t('tableHeader.optiuni')}}
                    </th>
                </tr>
            </tfoot>
        </table>
    </div>
</template>

<script>
import RolesService from '../../api-services/roles.service.js'
export default {
  name: 'roles',
  data () {
    return {
      roles: null
    }
  },
  methods: {
    getRoles () {
      this.roles = null
      this.$store.dispatch('showLoading')
      RolesService.getAll()
        .then((response) => {
          if (response.data.data.length > 0) {
            this.roles = response.data.data
          } else {
            this.roles = null
          }
          this.$store.dispatch('hideLoading')
        })
        .catch((error) => {
          console.log(error)
          this.$store.dispatch('hideLoading')
        })
    }
  },
  created () {
    this.getRoles()
  }
}
</script>
